/*
  PhotoHouse Preview / 2026-11-02.
  Keep all gift product images accessible after a variant causes
  Kingdom's filtered gallery to rebuild, while preserving native Shopify
  option/variant selection and inventory logic.
*/
(function(){
  'use strict';
  function list(root,selector){return Array.prototype.slice.call(root.querySelectorAll(selector));}
  function mount(article){
    if(!article||article.dataset.phGiftMediaMounted==='1')return;
    var gallery=article.querySelector('.product__gallery');
    var main=article.querySelector('.ctm_product_gallery_main');
    var rail=article.querySelector('[data-ph-v7-rail]');
    var variant=article.querySelector('select.productSelect[name="id"]');
    if(!gallery||!main||!rail||!variant||!article.classList.contains('ph-preview--gift'))return;
    var thumbs=list(rail,'[data-ph-v7-thumb][data-ph-v7-full]').map(function(button){
      return {button:button,id:button.getAttribute('data-ph-v7-thumb'),
        url:button.getAttribute('data-ph-v7-full'),
        small:(button.querySelector('img')||{}).src||'',
        alt:(button.querySelector('img')||{}).alt||''};
    }).filter(function(item){return Boolean(item.id&&item.url);});
    if(thumbs.length<2)return;
    var assigned=list(variant,'option').filter(function(option){
      return thumbs.some(function(media){return media.id===option.getAttribute('data-media-id');});
    });
    // A proven native product variant <-> image association is required.
    // Leave decorative media-only products and print-frame products untouched.
    if(assigned.length<1||article.querySelector('.ph-v2__option--frame'))return;
    article.dataset.phGiftMediaMounted='1';

    var stage=document.createElement('div');
    stage.className='ph-gift-media-stage';
    stage.setAttribute('data-ph-gift-media-stage','');
    stage.setAttribute('aria-label',/^he/i.test(document.documentElement.lang||'')?
      'תמונת המוצר שנבחרה':'Selected product image');
    stage.hidden=true;
    var photo=document.createElement('img');
    photo.className='ph-gift-media-photo';
    photo.alt='';
    photo.decoding='async';
    photo.loading='eager';
    var zoom=document.createElement('button');
    zoom.type='button';
    zoom.className='ph-gift-media-zoom';
    zoom.setAttribute('aria-label',/^he/i.test(document.documentElement.lang||'')?
      'הגדלת תמונת המוצר':'Enlarge product image');
    zoom.innerHTML='<svg viewBox="0 0 26 26" fill="none" aria-hidden="true"><circle cx="11" cy="11" r="7.5" stroke="currentColor" stroke-width="1.7"/><path d="M16.6 16.6L23 23M11 7.5v7M7.5 11h7" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>';
    stage.appendChild(photo);
    stage.appendChild(zoom);
    main.appendChild(stage);
    var sequence=0,loadedId='',requestedId='',manualId='',loadedURL='',currentId='';
    var dialog=null,dialogImage=null,frame=0;

    function desktop(){return window.matchMedia('(min-width:1024px)').matches;}
    function measure(){
      if(stage.hidden||!desktop())return;
      var box=gallery.getBoundingClientRect(),top=main.getBoundingClientRect().top||0;
      var h=window.innerHeight||800,w=box.width||gallery.clientWidth;
      var budget=Math.max(270,h-Math.max(top,92)-100);
      var px=Math.floor(Math.min(w,budget,820));
      if(px>=220&&main.style.getPropertyValue('--ph-gift-media-square')!==px+'px')
        main.style.setProperty('--ph-gift-media-square',px+'px');
    }
    function setStage(show){
      if(show && !desktop())show=false;
      stage.hidden=!show;
      article.classList.toggle('ph-gift-media-active',show);
      if(show)measure();
      else main.style.removeProperty('--ph-gift-media-square');
      return show;
    }
    function findById(id){return thumbs.find(function(m){return m.id===id;})||null;}
    function variantMedia(){
      var option=variant.options[variant.selectedIndex];
      return findById(option&&option.getAttribute('data-media-id')||'');
    }
    function mark(media){
      thumbs.forEach(function(m){
        var active=m===media;
        m.button.setAttribute('data-ph-gift-media-selected',active?'true':'false');
        m.button.setAttribute('aria-pressed',active?'true':'false');
        m.button.classList.toggle('is-selected',active);
      });
    }
    function showLoaded(media,url,seq){
      if(seq!==sequence||!article.isConnected)return;
      loadedId=media.id;requestedId='';currentId=media.id;loadedURL=url;
      photo.alt=media.alt||'';
      mark(media);
      setStage(true);
    }
    function load(media){
      if(!desktop()||!media)return;
      if(media.id===loadedId&&photo.complete&&photo.naturalWidth>40){
        currentId=media.id;setStage(true);mark(media);return;
      }
      if(media.id===requestedId)return;
      var seq=++sequence;requestedId=media.id;currentId=media.id;
      function attempt(url,isSmall){
        var preview=new Image();
        function fail(){
          if(seq!==sequence||!article.isConnected)return;
          if(!isSmall&&media.small&&media.small!==url)attempt(media.small,true);
          else {
            requestedId='';
            // The last successfully painted image remains visible. Never
            // replace it with a blank/incorrect media frame on a load error.
            if(!loadedId)setStage(false);
          }
        }
        preview.onload=function(){
          if(seq!==sequence||!article.isConnected)return;
          if(preview.naturalWidth<45){fail();return;}
          photo.onload=function(){showLoaded(media,url,seq);};
          photo.onerror=fail;
          photo.src=url;
          if(photo.complete&&photo.naturalWidth>40)showLoaded(media,url,seq);
        };
        preview.onerror=fail;
        preview.src=url;
      }
      attempt(media.url,false);
    }
    function desired(){
      return (manualId&&findById(manualId))||variantMedia();
    }
    function sync(){
      frame=0;
      if(!desktop()){setStage(false);return;}
      var m=desired();if(m)load(m);
    }
    function queue(){if(!frame)frame=window.requestAnimationFrame(sync);}
    function changed(){
      manualId='';
      queue();
      window.setTimeout(queue,70);
      window.setTimeout(queue,220);
    }
    variant.addEventListener('change',changed);
    var selectors=list(article,'.product__variant-holder select.product__variant');
    selectors.forEach(function(select){
      select.addEventListener('change',changed);
      if(window.jQuery&&window.jQuery.fn)window.jQuery(select).on('change.phGiftMedia',changed);
    });
    rail.addEventListener('click',function(e){
      var button=e.target&&e.target.closest&&e.target.closest('[data-ph-v7-thumb]');
      if(!button||!rail.contains(button)||!desktop())return;
      var media=thumbs.find(function(m){return m.button===button;});
      if(!media)return;
      // Capture BEFORE V7's thumbnail click listener. Never let Flickity
      // dispose of the stable strip while Kingdom rebuilds filtered slides.
      e.preventDefault();
      e.stopPropagation();
      if(e.stopImmediatePropagation)e.stopImmediatePropagation();
      manualId=media.id;
      var matched=assigned.find(function(option){
        return option.getAttribute('data-media-id')===media.id;
      });
      // Only a one-option Shopify product is safe to update from a photo.
      if(matched && selectors.length===1 && !matched.disabled){
        var select=selectors[0],txt=(matched.textContent||'').trim();
        var option=list(select,'option').find(function(o){
          return o.value===txt||(o.textContent||'').trim()===txt;
        });
        if(option && !option.disabled && select.value!==option.value){
          select.value=option.value;
          if(window.jQuery&&window.jQuery.fn)window.jQuery(select).trigger('change');
          else select.dispatchEvent(new Event('change',{bubbles:true}));
          // Any native change handlers will now update the actual variant.
          manualId=media.id;
        }
      }
      load(media);
      window.setTimeout(function(){manualId=media.id;queue();},120);
    },true);
    window.addEventListener('resize',function(){if(desktop())measure();else setStage(false);queue();},{passive:true});

    zoom.addEventListener('click',function(){
      if(!loadedURL||!window.HTMLDialogElement)return;
      if(!dialog){
        dialog=document.createElement('dialog');
        dialog.className='ph-qa-media-dialog';
        var close=document.createElement('button');
        close.className='ph-qa-media-close';close.type='button';close.textContent='×';
        close.setAttribute('aria-label',/^he/i.test(document.documentElement.lang||'')?'סגירה':'Close');
        dialogImage=document.createElement('img');
        dialogImage.className='ph-qa-media-image';
        dialog.appendChild(close);dialog.appendChild(dialogImage);
        document.body.appendChild(dialog);
        close.addEventListener('click',function(){dialog.close();});
        dialog.addEventListener('click',function(event){if(event.target===dialog)dialog.close();});
        dialog.addEventListener('close',function(){zoom.focus();});
      }
      dialogImage.src=loadedURL;dialogImage.alt=photo.alt;
      if(!dialog.open)dialog.showModal();
    });
    queue();
  }
  function boot(){
    if(!document.body||!document.body.classList.contains('ph-v1')||
      !document.body.classList.contains('template-product')||
      document.body.classList.contains('template-product-portfolio'))return;
    list(document,'article.product.page-section').forEach(mount);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);
  else boot();
  document.addEventListener('shopify:section:load',boot);
}());
